import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BreadcrumbsWidget, DataTableWrap } from "components";
import { IconButton, Skeleton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useResponseAll } from "hooks";
import {
  useDeleteProductMutation,
  useGetProductsMutation,
} from "redux/api/slices/server";
import SearchBar from "./SearchBar";

const GetProductsPage = () => {
  const [getProducts, products] = useGetProductsMutation();
  const { id } = useParams();
  const Id = parseInt(id);
  const [deleteProduct, deleteReq] = useDeleteProductMutation();

  const columns = [
    {
      name: "Ürün",
      selector: (row) => row.title,
      sortable: true,
      width: "450px",
    },
    {
      name: "Kategori",
      selector: (row) => row.category,
      sortable: true,
      width: "330px",
    },
    {
      name: "Makale",
      selector: (row) => row.article,
      sortable: true,
      width: "300px",
    },
    {
      name: "Görsel",
      sortable: true,
      width: "170px",
      cell: (row) => {
        return (
          <div className=" p-4 items-center w-40">
            <img
              src={`https://www.ferforjefiyatlari.web.tr/resimler/makaleler/${row.image}`}
              alt={row.title}
            />
          </div>
        );
      },
    },
    {
      right: true,
      width: "10px",
      cell: (row) => {
        return (
          <IconButton
            aria-label="detaitl"
            size="small"
            href={`/detail-product/${row.id}/${products.data?.categoryId}`}
          >
            <Edit fontSize="inherit" />
          </IconButton>
        );
      },
    },
  ];

  useEffect(() => {
    getProducts({ katid: Id });
  }, [Id, getProducts]);

  useResponseAll(deleteReq);

  return (
    <div className="w-full">
      <div className="mx-5 py-10">
        <BreadcrumbsWidget
          data={[{ title: "Ürünler", url: "/products/0" }]}
          activeItem={`${products.data?.category} Ürünleri`}
        />
        <SearchBar Arama={getProducts} data={products} id={Id} />
        <div className="w-full h-auto flex flex-col p-5 gap-4 border shadow bg-white">
          {products.isLoading ? (
            <Skeleton height={300} />
          ) : (
            <DataTableWrap
              title={`${products.data?.category} Ürünleri`}
              columns={columns}
              initialData={products.data?.list}
              externalFunction={deleteProduct}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default GetProductsPage;
